import { render, staticRenderFns } from "./Infographic.vue?vue&type=template&id=6e6186f4&"
import script from "./Infographic.vue?vue&type=script&lang=js&"
export * from "./Infographic.vue?vue&type=script&lang=js&"
import style0 from "./Infographic.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Infographic.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports